export default {
    home: {
        initializing: 'Initializing system...',
        fetchingToken: 'Obtaining security token...',
        loadingBusiness: 'Loading business system...',
        connectFailed: 'System connection failed. Please check your network or contact the administrator.'
    },
    sso: {
        redirecting: 'Performing secure redirect...'
    },
    tutor: {
        title: "AI Coach",
        buttonTitle: "AI Coach",
        historyTitle: "Conversation history",
        introduction: "I’m your Mark Simos AI Coach. What would you like to explore?",
        description: "I can consolidate data from different reports, explain game rules and business metrics, and illustrate tools and analytical methods with P0 (period 0) data. I do not provide specific decision recommendations.",
        suggestionsTitle: "You can ask:",
        checkCategory: "Decision check",
        checkQuestion: "Do the current factory price and promotion budget match?",
        historyCategory: "History comparison",
        historyQuestion: "Compare product pricing across completed periods",
        riskCategory: "Risk check",
        riskQuestion: "Which pricing decisions could create budget or channel risks?",
        nextCategory: "Next step",
        nextQuestion: "What should we check before reviewing our decisions?",
        trustNote: "AI analysis is for reference only. AI is not responsible for decision outcomes. Please use it with caution.",
        inputPlaceholder: "Ask a question…",
        currentCompany: "your company",
        close: "Close AI Coach",
        showHistory: "Show conversation history",
        hideHistory: "Collapse conversation history",
        myConversations: "My conversations",
        teamShared: "Team shared",
        teamNoteTitle: "Team sharing",
        teamNote: "Your teammates can view team questions and answers.",
        today: "Today",
        lastWeek: "Past 7 days",
        earlier: "Earlier",
        period: "Period {period}",
        conversationEmpty: "Ask the AI Coach a question...",
        noQuestions: "No questions yet"
    },
    history: {
        // {n} = last 4 digits of mobile
        askerMine: 'Me (Student {n})',
        askerOther: 'Student {n}'
    },
    chat: {
        me: 'Me',
        like: 'Like',
        dislike: 'Dislike',
        thinkingProcess: 'Thinking Process',
        thinking: 'Thinking...',
        inputPlaceholder: 'Type a message...',
        send: 'Send',
        loadingHistory: 'Loading history...',
        newMessage: 'New Message',
        sendFailed: '[Send failed] ',
        requestTimeout: 'The AI response timed out. Please ask again.'
    },
    socratic: {
        thinkTitle: 'AI Coach · Think it through',
        yourAnswer: 'Your answer',
        teamAnswer: 'Teammate’s answer',
        closeCountdown: 'Close in {seconds}s',
        skip: 'Skip',

        answerPlaceholder: 'Share your thoughts...',
        send: 'Send',
        waitingPeer: 'Waiting for teammate to answer...',
        close: 'Close'
    },
    facilitator: {
        title: 'Facilitator — AI Q&A',
        seminarLabel: 'Seminar',
        loading: 'Loading...',
        loadFailed: 'Failed to load data',
        noSeminar: 'No seminar specified',
        empty: 'No Q&A matches the selected filters',
        team: 'Team',
        period: 'Period',
        triggeredBy: 'Triggered by',
        question: 'AI question',
        answer: 'Student answer',
        answeredBy: 'Answered by',
        unanswered: 'Not answered yet',
        refresh: 'Refresh',
        questionCount: '{n} question(s)',
        chatTab: 'AI conversations',
        socraticTab: 'AI proactive Q&A',
        allTeams: 'All teams',
        allPeriods: 'All periods',
        studentQuestion: 'Student question',
        aiAnswer: 'AI reply',
        automaticTrigger: 'Automatic prompt',
        noReply: 'No AI reply available',
        emptyQuestion: 'No text question',
        export: 'Export course Q&A',
        partialWarning: 'Some Q&A could not be loaded. The export will include only loaded records. Refresh to retry loading the full history.',
        teamId: 'Team ID',
        recordType: 'Record type',
        student: 'Student',
        createdAt: 'Question time',
        questionContent: 'Question',
        answerContent: 'Reply',
        answeredAt: 'Answer time'
    }
};
